var map = {
	"./android-chrome-192x192.png": "NTIZ",
	"./android-chrome-512x512.png": "PfA/",
	"./apple-touch-icon.png": "+m7p",
	"./browserconfig.xml": "vm0V",
	"./favicon-16x16.png": "FcaM",
	"./favicon-32x32.png": "jeEr",
	"./favicon.ico": "DTEF",
	"./mstile-144x144.png": "ymUq",
	"./mstile-150x150.png": "VKeU",
	"./mstile-310x150.png": "KgUc",
	"./mstile-310x310.png": "bix9",
	"./mstile-70x70.png": "FAjq",
	"./safari-pinned-tab.svg": "vxFd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VCFN";